import { client } from './api-client';

export const COMPANY_LOGO_STORAGE_KEY = 'settings/company-logo.png';

export function getCompanyLogoStorageKey(value: string): string {
  const trimmed = value.trim();
  if (!trimmed) return '';

  try {
    const url = new URL(trimmed);
    const path = decodeURIComponent(url.pathname.replace(/^\/+/, ''));
    const [, ...keyParts] = path.split('/');

    return keyParts.join('/') || path;
  } catch {
    return trimmed;
  }
}

export async function fetchCompanyLogoUrl(): Promise<string | null> {
  try {
    return await client.getCompanyLogoURL.query();
  } catch {
    return null;
  }
}
